define("shared/components/shared/social/refresh-profile/index", ["exports", "@ember/component", "@ember/template-factory", "@ember/debug", "@ember/object", "@glimmer/component", "@glimmer/tracking", "later/utils/constants", "shared/utils/is-async-relation"], function (_exports, _component, _templateFactory, _debug, _object, _component2, _tracking, _constants, _isAsyncRelation) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/utils/constants",0,"shared/utils/is-async-relation"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#unless this.isLoading}}
    {{! Note: offload refresh handling to respective profile type-variants of buttons }}
    {{#if @socialProfile.isFacebook}}
      <Shared::Social::RefreshProfile::Facebook
        @buttonClass={{@buttonClass}}
        @buttonVariant={{@buttonVariant}}
        @isLocked={{@isLocked}}
        @onProfileRefresh={{this.onProfileRefresh}}
        @onProfileRefreshStart={{this.onProfileRefreshStart}}
        @severity={{this.severity}}
        @socialProfile={{@socialProfile}}
      />
    {{else if @socialProfile.isLinkedin}}
      <Shared::Social::RefreshProfile::Linkedin
        @buttonClass={{@buttonClass}}
        @buttonVariant={{@buttonVariant}}
        @isLocked={{@isLocked}}
        @onProfileRefresh={{this.onProfileRefresh}}
        @onProfileRefreshStart={{this.onProfileRefreshStart}}
        @severity={{this.severity}}
        @socialProfile={{@socialProfile}}
      />
    {{else if @socialProfile.isPinterest}}
      <Shared::Social::RefreshProfile::Pinterest
        @buttonClass={{@buttonClass}}
        @buttonVariant={{@buttonVariant}}
        @isLocked={{@isLocked}}
        @onProfileRefresh={{this.onProfileRefresh}}
        @onProfileRefreshStart={{this.onProfileRefreshStart}}
        @severity={{this.severity}}
        @socialProfile={{@socialProfile}}
      />
    {{else if @socialProfile.isTwitter}}
      <Shared::Social::RefreshProfile::Twitter
        @buttonClass={{@buttonClass}}
        @buttonVariant={{@buttonVariant}}
        @isLocked={{@isLocked}}
        @onProfileRefresh={{this.onProfileRefresh}}
        @onProfileRefreshStart={{this.onProfileRefreshStart}}
        @severity={{this.severity}}
        @socialProfile={{@socialProfile}}
      />
    {{/if}}
  {{/unless}}
  */
  {
    "id": "Ga4POKSF",
    "block": "[[[41,[51,[30,0,[\"isLoading\"]]],[[[41,[30,1,[\"isFacebook\"]],[[[1,\"    \"],[8,[39,2],null,[[\"@buttonClass\",\"@buttonVariant\",\"@isLocked\",\"@onProfileRefresh\",\"@onProfileRefreshStart\",\"@severity\",\"@socialProfile\"],[[30,2],[30,3],[30,4],[30,0,[\"onProfileRefresh\"]],[30,0,[\"onProfileRefreshStart\"]],[30,0,[\"severity\"]],[30,1]]],null],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isLinkedin\"]],[[[1,\"    \"],[8,[39,3],null,[[\"@buttonClass\",\"@buttonVariant\",\"@isLocked\",\"@onProfileRefresh\",\"@onProfileRefreshStart\",\"@severity\",\"@socialProfile\"],[[30,2],[30,3],[30,4],[30,0,[\"onProfileRefresh\"]],[30,0,[\"onProfileRefreshStart\"]],[30,0,[\"severity\"]],[30,1]]],null],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isPinterest\"]],[[[1,\"    \"],[8,[39,4],null,[[\"@buttonClass\",\"@buttonVariant\",\"@isLocked\",\"@onProfileRefresh\",\"@onProfileRefreshStart\",\"@severity\",\"@socialProfile\"],[[30,2],[30,3],[30,4],[30,0,[\"onProfileRefresh\"]],[30,0,[\"onProfileRefreshStart\"]],[30,0,[\"severity\"]],[30,1]]],null],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isTwitter\"]],[[[1,\"    \"],[8,[39,5],null,[[\"@buttonClass\",\"@buttonVariant\",\"@isLocked\",\"@onProfileRefresh\",\"@onProfileRefreshStart\",\"@severity\",\"@socialProfile\"],[[30,2],[30,3],[30,4],[30,0,[\"onProfileRefresh\"]],[30,0,[\"onProfileRefreshStart\"]],[30,0,[\"severity\"]],[30,1]]],null],[1,\"\\n  \"]],[]],null]],[]]]],[]]]],[]]]],[]],null]],[\"@socialProfile\",\"@buttonClass\",\"@buttonVariant\",\"@isLocked\"],false,[\"unless\",\"if\",\"shared/social/refresh-profile/facebook\",\"shared/social/refresh-profile/linkedin\",\"shared/social/refresh-profile/pinterest\",\"shared/social/refresh-profile/twitter\"]]",
    "moduleName": "shared/components/shared/social/refresh-profile/index.hbs",
    "isStrictMode": false
  });

  /**
   * Note: we only support a subset of profiles for this component.
   */
  const SUPPORTED_PROFILE_TYPES = [_constants.SocialProfileType.Facebook, _constants.SocialProfileType.Linkedin, _constants.SocialProfileType.Pinterest, _constants.SocialProfileType.Twitter];
  /**
   * Ensure the provided social profile is supported in this component.
   * @param socialProfile
   * @throws When social profile type is `undefined` or unsupported.
   */

  function ensureSupportedProfile(socialProfile) {
    if (!socialProfile.profileType) {
      (false && !(false) && (0, _debug.assert)('No profile type found on social profile'));
    }

    const isSupported = SUPPORTED_PROFILE_TYPES.includes(socialProfile.profileType);

    if (!isSupported) {
      (false && !(false) && (0, _debug.assert)('Unsupported profile type provided to `RefreshProfile` component'));
    }
  }

  let RefreshProfileComponent = (_class = class RefreshProfileComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "isLoading", _descriptor, this);

      if (!this.args.socialProfile) {
        (false && !(false) && (0, _debug.assert)('RefreshProfileComponent: missing required argument `socialProfile`'));
      }

      if ((0, _isAsyncRelation.isAsyncRelation)(this.args.socialProfile)) {
        this.args.socialProfile.then(socialProfile => {
          ensureSupportedProfile(socialProfile);
          this.isLoading = false;
        });
      } else {
        ensureSupportedProfile(this.args.socialProfile);
        this.isLoading = false;
      }
    }

    async onProfileRefreshStart(socialProfile) {
      this.args.onProfileRefreshStart?.(socialProfile);
    }

    async onProfileRefresh(socialProfile, result) {
      if (!result.error) {
        await socialProfile.refreshProfile();
        await socialProfile.reload();

        if (socialProfile.isPinterest) {
          // Note: to validate pinterest refresh was successful we attempt to
          // fetch boards, and if it fails with code "3", we know something
          // went wrong.
          const codeRed = 3;
          const response = await socialProfile.pinterestBoards();

          if (response.code !== codeRed) {
            // Note: this is to disable the socialProfile's `needsRefresh` state
            // for Pinterest accounts. We don't store (or use) an actual token on the client,
            // but we still use it to determine it's need for refreshing..?
            socialProfile.set('token', 'ARBITRARY_FAKE_TOKEN');
          }
        }
      }

      this.args.onProfileRefresh?.(socialProfile, result);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoading", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "onProfileRefreshStart", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onProfileRefreshStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onProfileRefresh", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onProfileRefresh"), _class.prototype)), _class);
  _exports.default = RefreshProfileComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, RefreshProfileComponent);
});